import * as React from "react";
import MemberStatTile from "../MemberStatTile";

const MembersStats = ({data}: any) => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:divide-x sm:grid-cols-2 lg:grid-cols-4">
      <MemberStatTile value={data.members} labelKey="users.label.members" imageName="members"></MemberStatTile>
      <MemberStatTile value={data.limitedAccessMembers} labelKey="users.label.limitedAccessMembers" imageName="limited-access-members"></MemberStatTile>
      <MemberStatTile value={data.pendingInvites} labelKey="users.label.pendingInvites" imageName="pending-invites"></MemberStatTile>
      <MemberStatTile value={data.newMembers} labelKey="users.label.newMembers" imageName="new-members"></MemberStatTile>
    </div>
  );
};

export default MembersStats;
